import { render, staticRenderFns } from "./ProfileDesktop.vue?vue&type=template&id=b988d42a&"
import script from "./ProfileDesktop.vue?vue&type=script&lang=js&"
export * from "./ProfileDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDesktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports